(() => {
  const root = document.getElementById('flayvr-customer-menu');
  if (!root) return;

  const loading = root.querySelector('[data-menu-loading]');
  const errorBox = root.querySelector('[data-menu-error]');
  const app = root.querySelector('[data-menu-app]');
  const apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
  const logoUrl = root.dataset.logoUrl || '';
  const params = new URLSearchParams(location.search);
  const token = params.get('token') || '';

  const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const api = (path) => `${apiBase}${path}`;

  if (!token) return fail();

  fetch(api(`/v1/menu?token=${encodeURIComponent(token)}`), {
    headers: {'accept':'application/json'},
    credentials: 'omit'
  })
    .then(async (r) => {
      if (!r.ok) throw new Error('menu_not_found');
      return r.json();
    })
    .then((payload) => {
      render(payload.menu, payload.review || {items:{}, week:{}});
      installSocialMeta(payload.menu);
      loading.hidden = true;
      app.hidden = false;
      bindProfileAnimations();
      requestAnimationFrame(() => requestAnimationFrame(positionReviewBelowThemeHeader));
    })
    .catch(fail);

  function positionReviewBelowThemeHeader(){
    const shell = app && app.querySelector('.flayvr-review-shell');
    if (!shell) return;

    // Measure the page root in document flow. If Shopify already reserves
    // space for its header, the computed clearance naturally falls back to 16px.
    const rootTop = root.getBoundingClientRect().top;
    const selectors = [
      'header',
      'nav',
      '[role="banner"]',
      '.header-wrapper',
      '.site-header',
      '.shopify-section-group-header-group',
      '[class*="header" i]',
      '[id*="header" i]'
    ];

    const seen = new Set();
    const candidates = [];
    selectors.forEach(selector => {
      try {
        document.querySelectorAll(selector).forEach(el => {
          if (seen.has(el) || root.contains(el)) return;
          seen.add(el);
          const style = getComputedStyle(el);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
          const r = el.getBoundingClientRect();
          if (r.width < 280 || r.height < 36 || r.height > 170) return;
          if (r.bottom <= 0 || r.top >= 170) return;
          candidates.push(r);
        });
      } catch (_) {}
    });

    if (!candidates.length) {
      shell.style.setProperty('--flayvr-review-clearance', '18px');
      return;
    }

    // Use the lowest edge of the visible top navigation/pill, then leave a
    // small optical gap. This is evaluated once, so no phantom gap appears
    // when an auto-hiding header disappears during scroll.
    const headerBottom = Math.max(...candidates.map(r => r.bottom));
    const clearance = Math.max(18, Math.min(150, Math.ceil(headerBottom - rootTop + 14)));
    shell.style.setProperty('--flayvr-review-clearance', `${clearance}px`);
  }


  function socialCardUrl(){
    return api(`/v1/menu/social-card?token=${encodeURIComponent(token)}`);
  }

  function socialShareUrl(){
    return api(`/share?token=${encodeURIComponent(token)}`);
  }

  function setMeta(kind,key,value){
    let el=document.head.querySelector(`meta[${kind}="${CSS.escape(key)}"]`);
    if(!el){el=document.createElement('meta');el.setAttribute(kind,key);document.head.appendChild(el)}
    el.setAttribute('content',value);
  }

  function installSocialMeta(menu){
    const firstName=(menu&&menu.customer&&menu.customer.first_name)||'Your';
    const title=`${firstName}’s Menu | Flayvr`;
    const description=`A chef-made weekly menu shaped around ${firstName}’s rhythm, tastes and preferences.`;
    const image=socialCardUrl();
    const share=socialShareUrl();
    document.title=title;
    setMeta('property','og:title',title);
    setMeta('property','og:description',description);
    setMeta('property','og:type','website');
    setMeta('property','og:url',share);
    setMeta('property','og:image',image);
    setMeta('property','og:image:secure_url',image);
    setMeta('property','og:image:width','1200');
    setMeta('property','og:image:height','630');
    setMeta('property','og:image:alt',`${firstName}’s personalised Flayvr menu`);
    setMeta('name','twitter:card','summary_large_image');
    setMeta('name','twitter:title',title);
    setMeta('name','twitter:description',description);
    setMeta('name','twitter:image',image);
    window.flayvrMenuShareUrl=share;
  }

  function fail(){
    if (loading) loading.hidden = true;
    if (app) app.hidden = true;
    if (errorBox) errorBox.hidden = false;
  }


  function render(menu, review){
    if (!menu || !menu.customer || !Array.isArray(menu.breakfast) || !Array.isArray(menu.lunch) || !Array.isArray(menu.dinner)) return fail();
    document.title = `Flayvr — ${menu.customer.first_name} Ami Menu`;
    app.innerHTML = [
      reviewShell(menu, review),
      coverPage(menu),
      mealPage(menu, 'Breakfast', menu.breakfast, '02 / 04 - Breakfast', 'Taste Match shows how closely each suitable meal aligns with your profile — after food rules, the energy target and protein goal have already been applied.'),
      mealPage(menu, 'Lunch', menu.lunch, '03 / 04 - Lunch', 'Lunches stay protein-led, bright and practical for the working week, while keeping ginger excluded throughout.'),
      dinnerPage(menu),
      weekReview(menu, review),
      '<div class="flayvr-toast" data-toast>Saved</div>'
    ].join('');
    bindReview(menu, review);
  }

  function pageHead(menu){
    return `<header class="flayvr-page-head"><img src="${esc(logoUrl)}" class="flayvr-logo" alt="Flayvr"><span>${esc(menu.week.label)}</span></header>`;
  }
  function summaryRow(label, value){
    return `<div class="flayvr-summary-row"><span>${esc(label)}</span><strong>${esc(value)}</strong></div>`;
  }
  function safetyRow(label, value, kind='avoid'){
    const cls = kind === 'allergy' ? 'flayvr-safety-allergy' : 'flayvr-safety-avoid';
    return `<div class="flayvr-summary-row flayvr-safety-row ${cls}"><span>${esc(label)}</span><strong><i aria-hidden="true"></i>${esc(value)}</strong></div>`;
  }

  function coverPage(menu){
    const s = menu.summary;
    const t = menu.taste;
    const e = menu.energy;
    return `<section class="flayvr-page flayvr-cover">
      ${pageHead(menu)}
      <div class="flayvr-cover-top">
        <div>
          <div class="flayvr-eyebrow">YOUR MENU FROM AMI</div>
          <h1>${esc(menu.customer.first_name)}, this week was cooked for you — not picked from a catalogue.</h1>
          <p class="flayvr-cover-copy">${esc(menu.intro)}</p>
        </div>
        <div class="flayvr-summary">
          ${summaryRow('Coverage', s.coverage)}
          ${summaryRow('Plan', s.plan)}
          ${summaryRow('Food profile', s.food_profile)}
          ${summaryRow('Spice', s.spice)}
          ${s.allergies ? safetyRow('Allergies', s.allergies, String(s.allergies).toLowerCase().includes('none') ? 'none' : 'allergy') : ''}
          ${s.cant_have ? safetyRow(s.cant_have_type || 'Hard food exclusion', s.cant_have, 'avoid') : ''}
          ${summaryRow('Primary goal', s.primary_goal)}
        </div>
      </div>
      <div class="flayvr-profile">
        <div class="flayvr-profile-title"><h2>Your profile shaped this week.</h2><span>${t.inferred ? 'AMI INFERRED' : 'TASTE PROFILE'}</span></div>
        <div class="flayvr-profile-top${menu.daily_rhythm ? ' has-rhythm' : ''}">
          <div class="flayvr-radar-wrap js-radar-animate" data-animate-on-view="radar">${radarSvg(t)}</div>
          ${menu.daily_rhythm ? rhythmHtml(menu.daily_rhythm, menu.customer.first_name) : ''}
        </div>
      </div>
      <div class="flayvr-energy">
        <div class="flayvr-energy-head"><div><div class="flayvr-week-label">THIS WEEK</div><h2>Energy target</h2></div><p class="flayvr-energy-note">${esc(e.note)}</p></div>
        <div class="flayvr-metrics">
          ${metric('Est. BMR',e.bmr)}${metric('Est. maintenance',e.maintenance)}${metric('Plan target',e.target)}${metric('Est. deficit',e.deficit)}${metric('Protein',e.protein)}
        </div>
        <p class="flayvr-caveat">${esc(e.caveat)}</p>
      </div>
    </section>`;
  }

  function metric(label,value){ return `<div class="flayvr-metric"><small>${esc(label)}</small><strong>${esc(value)}</strong></div>`; }
  function radarSvg(t){
    const labels = ['Adventure','Heat','Intensity','Acid','Texture','Sweet'];
    const vals = [t.adventure,t.heat,t.intensity,t.acid,t.texture,t.sweet].map(v => Math.max(0,Math.min(100,Number(v)||0)));
    const cx=120, cy=120, r=72;
    const pt=(i,rr)=>{const a=(-90+i*60)*Math.PI/180;return [cx+Math.cos(a)*rr,cy+Math.sin(a)*rr]};
    const poly=(rr)=>labels.map((_,i)=>pt(i,rr).map(n=>n.toFixed(1)).join(',')).join(' ');
    const shape=vals.map((v,i)=>pt(i,r*v/100).map(n=>n.toFixed(1)).join(',')).join(' ');
    const textPos = [
      [120,22,'middle'],[228,72,'end'],[228,164,'end'],[120,220,'middle'],[12,164,'start'],[12,72,'start']
    ];
    return `<svg class="flayvr-radar" viewBox="0 0 240 240" preserveAspectRatio="xMidYMid meet" role="img" aria-label="${esc('Inferred taste radar for '+(t.name||'this customer'))}">
      ${[18,36,54,72].map(rr=>`<polygon class="flayvr-radar-grid" points="${poly(rr)}"></polygon>`).join('')}
      ${labels.map((_,i)=>{const [x,y]=pt(i,r);return `<line class="flayvr-radar-axis" x1="120" y1="120" x2="${x.toFixed(1)}" y2="${y.toFixed(1)}"></line>`}).join('')}
      <polygon class="shape flayvr-radar-shape" points="${shape}"></polygon>
      ${vals.map((v,i)=>{const [x,y]=pt(i,r*v/100);return `<circle class="flayvr-radar-point" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="3"></circle>`}).join('')}
      ${labels.map((l,i)=>`<text x="${textPos[i][0]}" y="${textPos[i][1]}" text-anchor="${textPos[i][2]}">${esc(l)}</text>`).join('')}
    </svg>`;
  }

  function rhythmHtml(rhythm, firstName){
    const safeValue=(v)=>Math.max(0,Math.min(100,Number(v)||0));
    const point=(key,label,sub,fallback)=>{
      const raw=rhythm[key];
      if(raw && typeof raw === 'object') return {label:raw.label||label,sub:raw.sub||raw.name||sub,value:safeValue(raw.value)};
      return {label,sub,value:safeValue(raw ?? fallback)};
    };
    const morning=point('morning','Morning','Sluggishness',70);
    const afternoon=point('afternoon','Afternoon','Focus dips',79);
    const evening=point('evening','Evening','Restlessness',60);
    const y=(v)=>300-(v*2.5);
    const y1=y(morning.value), y2=y(afternoon.value), y3=y(evening.value);
    const path=`M70 ${y1.toFixed(1)} C210 ${(y1-26).toFixed(1)} 330 ${(y2+4).toFixed(1)} 450 ${y2.toFixed(1)} C590 ${(y2+2).toFixed(1)} 710 ${(y3+10).toFixed(1)} 830 ${y3.toFixed(1)}`;
    const area=`${path} L830 302 L70 302 Z`;
    const aria=`${firstName || 'Customer'} daily rhythm: ${morning.label.toLowerCase()} ${morning.sub.toLowerCase()} ${morning.value}, ${afternoon.label.toLowerCase()} ${afternoon.sub.toLowerCase()} ${afternoon.value}, ${evening.label.toLowerCase()} ${evening.sub.toLowerCase()} ${evening.value}`;
    const insight=rhythm.insight || 'Front-load steadier protein and brightness for the morning, protect the afternoon dip with satisfying lunches and snacks, then keep dinner calmer and less stimulating to support a better wind-down.';
    return `<div class="flayvr-rhythm js-rhythm-animate" data-animate-on-view="rhythm">
      <div class="flayvr-rhythm-head"><div class="flayvr-rhythm-kicker">Daily rhythm</div><div class="flayvr-rhythm-source">${esc('From your questionnaire')}</div></div>
      <div class="flayvr-rhythm-chart">
        <svg viewBox="0 0 900 390" role="img" aria-label="${esc(aria)}">
          <line class="flayvr-rhythm-base" x1="70" y1="302" x2="830" y2="302"/>
          <path class="flayvr-rhythm-area" d="${area}"/>
          <path class="flayvr-rhythm-line" pathLength="1" d="${path}"/>
          <circle class="flayvr-rhythm-dot d1" cx="70" cy="${y1.toFixed(1)}" r="7"/>
          <circle class="flayvr-rhythm-dot d2" cx="450" cy="${y2.toFixed(1)}" r="7"/>
          <circle class="flayvr-rhythm-dot d3" cx="830" cy="${y3.toFixed(1)}" r="7"/>
          <text class="flayvr-rhythm-value" x="70" y="${(y1-28).toFixed(1)}" text-anchor="start"><tspan class="js-count" data-value="${morning.value}">${morning.value}</tspan></text>
          <text class="flayvr-rhythm-value" x="450" y="${(y2-28).toFixed(1)}" text-anchor="middle"><tspan class="js-count" data-value="${afternoon.value}">${afternoon.value}</tspan></text>
          <text class="flayvr-rhythm-value" x="830" y="${(y3-28).toFixed(1)}" text-anchor="end"><tspan class="js-count" data-value="${evening.value}">${evening.value}</tspan></text>
          <text class="flayvr-rhythm-label" x="70" y="334" text-anchor="start">${esc(morning.label)}</text>
          <text class="flayvr-rhythm-sub" x="70" y="359" text-anchor="start">${esc(morning.sub)}</text>
          <text class="flayvr-rhythm-label" x="450" y="334" text-anchor="middle">${esc(afternoon.label)}</text>
          <text class="flayvr-rhythm-sub" x="450" y="359" text-anchor="middle">${esc(afternoon.sub)}</text>
          <text class="flayvr-rhythm-label" x="830" y="334" text-anchor="end">${esc(evening.label)}</text>
          <text class="flayvr-rhythm-sub" x="830" y="359" text-anchor="end">${esc(evening.sub)}</text>
        </svg>
      </div>
      <div class="flayvr-rhythm-insight"><span>How Ami uses this</span><p>${esc(insight)}</p></div>
    </div>`;
  }

  function bindProfileAnimations(){
    const blocks=[...app.querySelectorAll('[data-animate-on-view]')];
    if(!blocks.length)return;
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const runCounters=(block)=>{
      block.querySelectorAll('.js-count').forEach(el=>{
        if(el.dataset.counted==='true')return;
        el.dataset.counted='true';
        const end=Number(el.dataset.value||0);
        if(reduce){el.textContent=String(end);return;}
        const start=performance.now(),duration=850;
        const step=(now)=>{const p=Math.min(1,(now-start)/duration);const eased=1-Math.pow(1-p,3);el.textContent=String(Math.round(end*eased));if(p<1)requestAnimationFrame(step)};
        el.textContent='0';requestAnimationFrame(step);
      });
    };
    const reveal=(block)=>{if(block.classList.contains('is-visible'))return;block.classList.add('is-visible');if(block.dataset.animateOnView==='rhythm')runCounters(block)};
    if(reduce||!('IntersectionObserver' in window)){blocks.forEach(reveal);return;}
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)return;reveal(entry.target);observer.unobserve(entry.target)})},{threshold:.28,rootMargin:'0px 0px -10% 0px'});
    blocks.forEach(block=>observer.observe(block));
  }

  function sectionHeader(title,count,copy){
    return `<div class="flayvr-section-head"><div><h2>${esc(title)}</h2><p>${esc(copy)}</p></div><span>${esc(count)}</span></div>`;
  }

  function mealPage(menu,title,items,_footerLabel,copy){
    return `<section class="flayvr-page">
      ${pageHead(menu)}
      ${sectionHeader(title,`${items.length} meals`,copy)}
      <div class="flayvr-meal-grid">${items.map((item,i)=>mealCard(item,title.toLowerCase(),i===items.length-1)).join('')}</div>
    </section>`;
  }

  function mealCard(item,type,isLast){
    const id=`${type}-day-${item.day}`;
    return `<article class="flayvr-meal-card${isLast?' flayvr-wide':''}" data-item-id="${esc(id)}">
      <div class="flayvr-card-top"><span class="flayvr-day">DAY ${esc(item.day)}</span><div class="flayvr-match"><b>${esc(item.match)}%</b> Taste match</div></div>
      <h3>${esc(item.title)}</h3>
      <p class="flayvr-desc">${esc(item.description)}</p>
      <div class="flayvr-meta"><span>${esc(item.protein)}</span><i>·</i><span>${esc(item.kcal)}</span>${item.tag?`<span class="flayvr-tag">${esc(item.tag)}</span>`:''}</div>
      <div class="flayvr-why"><strong>Why Ami picked this</strong><p>${esc(item.why)}</p></div>
      ${reviewTools(id,item.title)}
    </article>`;
  }

  function dinnerPage(menu){
    const items=menu.dinner;
    const copy='Sweet snacks are included deliberately across the week. Ginger stays excluded through every dinner, sauce and snack.';
    return `<section class="flayvr-page">
      ${pageHead(menu)}
      ${sectionHeader('Dinner + snacks',`${items.length} dinners + ${items.length} snacks`,copy)}
      <div class="flayvr-meal-grid">${items.map((item,i)=>dinnerCard(item,i===items.length-1)).join('')}</div>
    </section>`;
  }

  function dinnerCard(item,isLast){
    const id=`dinner-day-${item.day}`, sn=item.snack||{};
    return `<article class="flayvr-meal-card flayvr-dinner-card${isLast?' flayvr-wide':''}" data-item-id="${esc(id)}">
      <div class="flayvr-card-top"><span class="flayvr-day">DAY ${esc(item.day)}</span><div class="flayvr-match"><b>${esc(item.match)}%</b> Taste match</div></div>
      <h3>${esc(item.title)}</h3><p class="flayvr-desc">${esc(item.description)}</p>
      <div class="flayvr-meta"><span>${esc(item.protein)}</span><i>·</i><span>${esc(item.kcal)}</span></div>
      <div class="flayvr-why"><strong>Why Ami picked this</strong><p>${esc(item.why)}</p></div>
      <div class="flayvr-snack-pill"><span class="flayvr-snack-label">SNACK</span><strong>${esc(sn.title)}</strong><span>${esc(sn.type)} · ${esc(sn.protein)} · ${esc(sn.kcal)}</span></div>
      ${reviewTools(id,item.title)}
    </article>`;
  }

  function reviewTools(id,title){
    return `<div class="flayvr-review-tools" data-review-tools data-item-id="${esc(id)}" data-item-title="${esc(title)}">
      <div class="flayvr-review-tools-label"><span>Help Ami learn</span><span class="flayvr-meal-save-state" data-meal-save-state></span></div>
      <div class="flayvr-review-actions">
        <button type="button" class="flayvr-review-action" data-value="loved">Loved</button>
        <button type="button" class="flayvr-review-action" data-value="good">Good</button>
        <button type="button" class="flayvr-review-action not-again" data-value="not_again">Not again</button>
        <button type="button" class="flayvr-review-action swap" data-value="swap">Swap next week</button>
      </div>
      <textarea class="flayvr-review-note" data-review-note maxlength="1000" placeholder="Anything Ami should remember about this meal?"></textarea>
      <div class="flayvr-swap-confirm" data-swap-confirm hidden>
        <span class="flayvr-swap-hint">Tell Ami what you would prefer instead. Your review count changes only after you confirm.</span>
        <div class="flayvr-swap-confirm-actions">
          <button type="button" class="flayvr-swap-cancel" data-swap-cancel>Cancel</button>
          <button type="button" class="flayvr-swap-save" data-swap-save disabled>Confirm swap</button>
        </div>
      </div>
    </div>`;
  }

  function reviewShell(menu,review){
    const reviewed=Object.values(review.items||{}).filter(x=>x&&x.rating).length;
    return `<div class="flayvr-review-shell">
      <div><h2>Ami is always learning.</h2><p>Review meals as you go. What you love, skip or want changed becomes part of the next menu brief.</p></div>
      <div class="flayvr-review-status"><span class="flayvr-review-progress"><b data-review-count>${reviewed}</b> / 21 reviewed</span><button type="button" class="flayvr-share-cta" data-share-menu>Share menu</button><button type="button" class="flayvr-review-cta" data-review-week>Review your week</button></div>
    </div>`;
  }

  function weekReview(menu,review){
    const approved=review.week&&review.week.approved_at;
    return `<div class="flayvr-week-review">
      <h2>Ready to approve your menu?</h2>
      <p>Approve once you’re happy with this week’s menu. Flayvr will send the approval to the kitchen. You can still review meals as you eat them — Ami will use that feedback when shaping your next menu.</p>
      <textarea class="flayvr-week-note" data-week-note maxlength="1500" placeholder="Optional note for the kitchen before you approve...">${esc((review.week&&review.week.note)||'')}</textarea>
      <div class="flayvr-week-actions"><span class="flayvr-saved-state" data-week-save-state>${approved?`Approved ${esc(approved)}`:'Awaiting your approval'}</span><button class="flayvr-approve-btn" data-approve-week type="button" ${approved?'disabled':''}>${approved?'Menu approved':'Approve menu'}</button></div>
    </div>`;
  }

  function bindReview(menu,review){
    const state={items:{...(review.items||{})},week:{...(review.week||{})}};
    let timer;
    const countEl=app.querySelector('[data-review-count]');
    const toastEl=app.querySelector('[data-toast]');
    const showToast=(msg)=>{toastEl.textContent=msg;toastEl.classList.add('show');clearTimeout(toastEl._t);toastEl._t=setTimeout(()=>toastEl.classList.remove('show'),1400)};
    const showApprovalPopup=()=>{
      let modal=document.getElementById('flayvr-approval-modal');
      if(!modal){
        const style=document.createElement('style');
        style.id='flayvr-approval-modal-style';
        style.textContent=`
          .flayvr-approval-modal{position:fixed;inset:0;z-index:99999;display:grid;place-items:center;padding:24px;background:rgba(20,20,20,.28);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);opacity:0;visibility:hidden;transition:opacity .18s ease,visibility .18s ease}
          .flayvr-approval-modal.is-open{opacity:1;visibility:visible}
          .flayvr-approval-dialog{width:min(520px,100%);background:#F5F2EB;color:#151515;border:1px solid #D8D2C8;border-radius:24px;padding:30px 30px 26px;box-shadow:0 18px 55px rgba(20,20,20,.14);transform:translateY(8px) scale(.985);transition:transform .18s ease}
          .flayvr-approval-modal.is-open .flayvr-approval-dialog{transform:none}
          .flayvr-approval-kicker{margin:0 0 12px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#6D6A65}
          .flayvr-approval-dialog h3{margin:0;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:34px;line-height:1.05;font-weight:300;letter-spacing:-.035em}
          .flayvr-approval-dialog p{margin:16px 0 0;font-size:16px;line-height:1.55;color:#5F5B55}
          .flayvr-approval-done{margin-top:24px;appearance:none;border:0;border-radius:999px;background:#E8343F;color:#fff;padding:12px 20px;font:500 14px/1 "Helvetica Neue",Helvetica,Arial,sans-serif;cursor:pointer}
          @media (max-width:640px){.flayvr-approval-modal{padding:18px}.flayvr-approval-dialog{border-radius:20px;padding:26px 22px 22px}.flayvr-approval-dialog h3{font-size:30px}}
          @media (prefers-reduced-motion:reduce){.flayvr-approval-modal,.flayvr-approval-dialog{transition:none}}
        `;
        document.head.appendChild(style);
        modal=document.createElement('div');
        modal.id='flayvr-approval-modal';
        modal.className='flayvr-approval-modal';
        modal.setAttribute('role','dialog');
        modal.setAttribute('aria-modal','true');
        modal.setAttribute('aria-labelledby','flayvr-approval-title');
        modal.innerHTML=`
          <div class="flayvr-approval-dialog">
            <div class="flayvr-approval-kicker">Flayvr kitchen</div>
            <h3 id="flayvr-approval-title">Menu approved.</h3>
            <p>Your kitchen team has it from here. You can still review meals as you go — Ami will use that feedback when shaping your next menu.</p>
            <button type="button" class="flayvr-approval-done">Done</button>
          </div>`;
        document.body.appendChild(modal);
        const close=()=>{modal.classList.remove('is-open');document.body.style.overflow='';};
        modal.querySelector('.flayvr-approval-done').addEventListener('click',close);
        modal.addEventListener('click',e=>{if(e.target===modal)close();});
        document.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal.classList.contains('is-open'))close();});
      }
      document.body.style.overflow='hidden';
      modal.classList.add('is-open');
      setTimeout(()=>modal.querySelector('.flayvr-approval-done')?.focus(),20);
    };
    const updateCount=()=>{countEl.textContent=Object.values(state.items).filter(x=>x&&x.rating).length};
    const post=async(path,body)=>{
      const r=await fetch(api(path),{method:'POST',headers:{'content-type':'application/json','accept':'application/json'},body:JSON.stringify({...body,token,menu_id:menu.menu_id})});
      let payload={};
      try{payload=await r.json()}catch{}
      if(!r.ok){
        const err=new Error(payload.error||'save_failed');
        err.code=payload.code||payload.error||'save_failed';
        throw err;
      }
      return payload;
    };

    const shareBtn=app.querySelector('[data-share-menu]');
    if(shareBtn){
      shareBtn.addEventListener('click',async()=>{
        const firstName=(menu.customer&&menu.customer.first_name)||'My';
        const shareData={
          title:`${firstName}’s Menu | Flayvr`,
          text:`My personalised Flayvr menu, shaped around my rhythm and tastes.`,
          url:socialShareUrl()
        };
        try{
          if(navigator.share){await navigator.share(shareData);return;}
          await navigator.clipboard.writeText(shareData.url);
          showToast('Share link copied');
        }catch(err){
          if(err&&err.name==='AbortError')return;
          try{await navigator.clipboard.writeText(shareData.url);showToast('Share link copied')}
          catch{showToast('Couldn’t copy link')}
        }
      });
    }

    const reviewWeekBtn=app.querySelector('[data-review-week]');
    if(reviewWeekBtn){
      reviewWeekBtn.addEventListener('click',()=>{
        const tools=[...app.querySelectorAll('[data-review-tools]')];
        const target=tools.find(tool=>{
          const id=tool.dataset.itemId;
          return !(state.items[id]&&state.items[id].rating);
        }) || app.querySelector('.flayvr-week-review');
        if(!target)return;
        target.scrollIntoView({behavior:'smooth',block:'center'});
        if(target.matches&&target.matches('[data-review-tools]')){
          target.classList.add('flayvr-review-focus');
          setTimeout(()=>target.classList.remove('flayvr-review-focus'),1500);
        }
      });
    }


    app.querySelectorAll('[data-review-tools]').forEach(tool=>{
      const id=tool.dataset.itemId, title=tool.dataset.itemTitle;
      const existing=state.items[id]||{};
      const note=tool.querySelector('[data-review-note]');
      const status=tool.querySelector('[data-meal-save-state]');
      const swapPanel=tool.querySelector('[data-swap-confirm]');
      const swapSave=tool.querySelector('[data-swap-save]');
      const swapCancel=tool.querySelector('[data-swap-cancel]');
      let pendingSwap=false;
      let swapOriginal=null;

      const markActive=(value)=>{
        tool.querySelectorAll('[data-value]').forEach(b=>{b.classList.remove('active','pending')});
        if(value){const b=tool.querySelector(`[data-value="${CSS.escape(value)}"]`);if(b)b.classList.add('active')}
      };
      const closeSwapPanel=()=>{
        pendingSwap=false;
        swapPanel.hidden=true;
        tool.querySelectorAll('[data-value]').forEach(b=>b.classList.remove('pending'));
        note.placeholder='Anything Ami should remember about this meal?';
      };

      if(existing.rating) markActive(existing.rating);
      if(existing.note){note.value=existing.note;note.classList.add('open')}

      tool.querySelectorAll('[data-value]').forEach(btn=>btn.addEventListener('click',()=>{
        const value=btn.dataset.value;

        if(value==='swap'){
          swapOriginal={...(state.items[id]||{})};
          pendingSwap=true;
          tool.querySelectorAll('[data-value]').forEach(b=>b.classList.remove('active','pending'));
          btn.classList.add('pending');
          note.classList.add('open');
          note.placeholder='What would you prefer instead? Tell Ami what to swap, or what you want more of.';
          swapPanel.hidden=false;
          swapSave.disabled=!note.value.trim();
          status.textContent='Swap not saved yet';
          requestAnimationFrame(()=>note.focus({preventScroll:true}));
          return;
        }

        closeSwapPanel();
        markActive(value);
        note.classList.add('open');
        state.items[id]={...(state.items[id]||{}),rating:value,note:note.value||''};
        updateCount();
        status.textContent='Saving…';
        clearTimeout(timer);
        timer=setTimeout(async()=>{
          try{await post('/v1/menu/feedback',{item_id:id,item_title:title,rating:value,note:note.value||''});status.textContent='Saved';showToast('Saved to Flayvr')}
          catch{status.textContent='Couldn’t save';showToast('Please try again')}
        },250);
      }));

      swapCancel.addEventListener('click',()=>{
        if(!pendingSwap)return;
        closeSwapPanel();
        if(swapOriginal&&swapOriginal.rating){
          state.items[id]={...swapOriginal};
          markActive(swapOriginal.rating);
          note.value=swapOriginal.note||'';
          if(swapOriginal.note)note.classList.add('open'); else note.classList.remove('open');
        }else{
          markActive(null);
          note.value='';
          note.classList.remove('open');
        }
        status.textContent='';
        swapOriginal=null;
      });

      swapSave.addEventListener('click',async()=>{
        if(!pendingSwap)return;
        const swapNote=note.value.trim();
        if(!swapNote){
          swapSave.disabled=true;
          status.textContent='Add a note first';
          note.focus();
          return;
        }
        swapSave.disabled=true;
        status.textContent='Saving…';
        try{
          await post('/v1/menu/feedback',{item_id:id,item_title:title,rating:'swap',note:swapNote});
          state.items[id]={...(state.items[id]||{}),rating:'swap',note:swapNote};
          closeSwapPanel();
          markActive('swap');
          updateCount();
          status.textContent='Saved';
          showToast('Swap saved to Flayvr');
          swapOriginal=null;
        }catch{
          swapSave.disabled=false;
          status.textContent='Couldn’t save';
          showToast('Please try again');
        }
      });

      note.addEventListener('input',()=>{
        if(pendingSwap){
          swapSave.disabled=!note.value.trim();
          status.textContent=note.value.trim()?'Ready to confirm':'Swap not saved yet';
          return;
        }
        state.items[id]={...(state.items[id]||{}),note:note.value};
        const rating=state.items[id].rating||null;
        if(!rating)return;
        status.textContent='Saving…';
        clearTimeout(timer);
        timer=setTimeout(async()=>{
          try{await post('/v1/menu/feedback',{item_id:id,item_title:title,rating,note:note.value||''});status.textContent='Saved'}
          catch{status.textContent='Couldn’t save'}
        },650);
      });
    });

    const weekNote=app.querySelector('[data-week-note]');
    const weekState=app.querySelector('[data-week-save-state]');
    const approve=app.querySelector('[data-approve-week]');
    approve.addEventListener('click',async()=>{
      approve.disabled=true;approve.textContent='Approving…';weekState.textContent='Sending to the kitchen…';
      try{
        const r=await post('/v1/menu/approve',{note:weekNote.value||''});
        weekState.textContent='Approved';
        approve.textContent='Menu approved';
        approve.disabled=true;
        showApprovalPopup();
      }catch(err){
        approve.disabled=false;
        approve.textContent='Approve menu';
        weekState.textContent='Couldn’t save — try again';
        showToast('Please try again');
      }
    });
  }

  let flayvrHeaderResizeTimer;
  window.addEventListener('resize', () => {
    if (window.scrollY > 120) return;
    clearTimeout(flayvrHeaderResizeTimer);
    flayvrHeaderResizeTimer = setTimeout(positionReviewBelowThemeHeader, 120);
  }, {passive:true});
})();
